import React from 'react';
import PropTypes from 'prop-types';

const ChartLegend = ({ legendElements }) => {
    return (
        <div className="gds-legend -m-t-4 -m-t-3-md">
            <ul className="gds-legend__items">
                {legendElements &&
                    legendElements.map(({ icon, label, color }, index) => {
                        const hasLegendIcon = icon;
                        const isDashedLine = icon && icon == 'dashed-line';
                        return (
                            <li key={index} className="gds-legend__item">
                                {hasLegendIcon ? (
                                    isDashedLine ? (
                                        <i
                                            className="gg-border-style-dashed"
                                            style={{
                                                color: color,
                                            }}
                                        />
                                    ) : (
                                        <i
                                            className="gg-border-style-solid"
                                            style={{
                                                color: color,
                                            }}
                                        />
                                    )
                                ) : (
                                    <span
                                        className="gds-legend__swatch gds-legend__swatch--square"
                                        style={{
                                            boxShadow: 'none',
                                            backgroundColor: color,
                                        }}
                                    />
                                )}
                                <span className="gds-legend__label -m-l-2">
                                    {label}
                                </span>
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
};

ChartLegend.propTypes = {
    legendElements: PropTypes.array.isRequired,
};

export default ChartLegend;
